<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'time-off-v3.selectADate' | translate }}</mat-label>
            <input
                class="d-none"
                name="date"
                #holidayDate="ngModel"
                required
                [(ngModel)]="holiday.date"
                matInput
                type="text"
            />
            <mat-error *ngIf="holidayDate.invalid && holidayDate.touched">{{
                holidayDate.errors | formErrors
            }}</mat-error>
            <mat-calendar #calendar [(selected)]="holiday.date"></mat-calendar>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'time-off-v3.holidayName' | translate }}</mat-label>
            <input name="name" #holidayName="ngModel" required [(ngModel)]="holiday.name" matInput type="text" />
            <mat-error *ngIf="holidayName.invalid && holidayName.touched">{{
                holidayName.errors | formErrors
            }}</mat-error>
        </mat-form-field>
    </div>
</form>
